import type { CmmdBootstrapData, CmmdProfileData, CmmdUserIdentity } from "@cmmd-forge/contracts";

export interface CmmdProfileSummary {
  readonly displayName: string;
  readonly email: string;
  readonly avatarUrl: string | null;
  readonly username: string;
  readonly warnings: ReadonlyArray<string>;
}

export interface CmmdProfilePermissions {
  readonly isAdmin: boolean;
  readonly canManageMembers: boolean;
  readonly canManageApps: boolean;
}

export function formatCmmdProfileDisplayName(identity: CmmdUserIdentity): string {
  const name = [identity.firstName, identity.lastName]
    .map((part) => part?.trim() ?? "")
    .filter(Boolean)
    .join(" ");
  return name || identity.email;
}

export function resolveCmmdProfileSummary(profile: CmmdProfileData): CmmdProfileSummary {
  return {
    displayName: formatCmmdProfileDisplayName(profile.identity),
    email: profile.identity.email,
    avatarUrl: profile.identity.avatarUrl ?? null,
    username: profile.identity.username,
    warnings: profile.warnings,
  };
}

export function resolveCmmdProfilePermissions(
  bootstrap: CmmdBootstrapData,
): CmmdProfilePermissions {
  return {
    isAdmin: bootstrap.permissions.isAdmin,
    canManageMembers: bootstrap.permissions.canManageMembers,
    canManageApps: bootstrap.permissions.canManageApps,
  };
}
